import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Alert} from 'reactstrap';
import reportsActionCreators from '../../../store/reports/action-creators/index';
import trainingPhasesActionCreators from '../../../store/training-phases/action-creators/index';
import ReportTableRow from './ReportTableRow';
import departmentSettingsSelectors from "../../../store/department-settings/selectors";
import './ReportTable.scss';
import classNames from 'classnames'
import SignActorsManage from "../../oits/SignActorsManage";
import Modal from "../../../../shared/ui/Modal";
import SignActorsManageSingle from "../../oits/SignActorsManageSingle";
import oitsActionCreators from "../../../store/oits/action-creators/oits";
import {ApiPost} from "../../../../shared/services/api-service";

class ReportTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredReports: this.filterReports(this.props.reports),
      filterByType: '',
      filterByProgress: 'in-progress',
      sortBy: null,
      sortDirection: 'asc',
      editingApprover: null
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillReceiveProps(nextProps) {
    if (nextProps.reports) {
      this.setState({
        filteredReports: this.sortReports(this.filterReports(nextProps.reports)),
        filterByType: '',
        filterByProgress: ''
      });
    }
  }

  get critiqueFormTypes() {
    return this.props.settings.critiqueFormTypes ? this.props.settings.critiqueFormTypes : ['ftc'];
  }

  // ----------------------
  // Methods
  // ----------------------

  onSendReminder(reportGuid) {
    const formData = {
      guid: reportGuid,
      sentAt: new Date().toISOString(),
    };
    this.props.sendReminder(formData);
  }

  openEditingApprover(data) {
    this.setState({
      editingApprover: {
        guid: data.report.guid,
        formType: data.report.type,
        actor: data.actor,
        signFlowStep: data.signFlowStep,
        signFlow: data.report.signFlow,
        signActors: data.report.signActors,
        trainingPhaseSignActors: data.report.trainingPhaseSignActor,
        phaseGuid: data.report.trainingPhaseGuid
      }
    })
  }

  notifyApprover(data) {
     ApiPost(`/api/v1/reports/${data.report.guid}/send-reminder`)
      .then(() => {
        this.setState({
          editingApprover: null
        })
      })
  }

  get departmentForms() {
    const forms = this.props.forms.reduce((acc, form) => {
      if (!acc[form.type] || acc.length === 0) {
        acc[form.type] = {
          type: form.type,
          name: form.name
        }

        return acc;
      }

      return acc;
    }, []);

    return Object.values(forms)
  }

  filterReportsByTypeAndProgress(reportType, reportProgress) {
    let reports = this.filterReports(this.props.reports);

    const filteredReports = reports.filter(report => {
      if (reportProgress === 'scheduled' && reportProgress !== '') {
        return (report.status === 'scheduled' || report.status === 'draft')
          && (report.getIsDueInFuture())
          && (!reportType || reportType === report.type);
      } else if (reportProgress === 'in-progress' && reportProgress !== '') {
        return (
          (report.status === 'scheduled' || report.status === 'draft')
          && !report.getIsDueInFuture()
        ) || (
          (report.status !== 'scheduled' && report.status !== 'draft')
        ) && (!reportType || reportType === report.type);
      } else if (reportProgress === '' && reportType) {
        return reportType === report.type;
      } else if (reportProgress === '') {
        return true;
      }
    });

    this.setState({
      filteredReports: this.sortReports(filteredReports),
      filterByType: reportType,
      filterByProgress: reportProgress
    });
  }

  sortByProperty(property) {
    let sortBy = this.state.sortBy, sortDirection = 'asc';

    if (this.state.sortBy === property && this.state.sortDirection === 'asc') {
      sortDirection = 'desc'
    } else if (this.state.sortBy === property && this.state.sortDirection === 'desc') {
      sortBy = null;
      sortDirection = 'asc'
    } else {
      sortBy = property;
      sortDirection = 'asc'
    }

    this.setState({
      sortBy,
      sortDirection
    }, () => {
      this.setState({
        filteredReports: this.sortReports(this.state.filteredReports)
      })
    })
  }

  sortReports(reports) {
    if (!this.state.sortBy) {
      return reports
    }
    return [...reports].sort((a, b) => {
      let sortResult = 0;
      let sortPropA = a[this.state.sortBy], sortPropB = b[this.state.sortBy], sortFunction = 'string';
      if (this.state.sortBy === 'date') {
        if ((new Date(a.rawDate)).getTime() < (new Date(b.rawDate)).getTime()) {
          sortResult = 1
        } else {
          sortResult = -1
        }

        sortFunction = null;
      }

      if(this.state.sortBy === 'name') {
        sortPropA = a.getFullNameFor('acknowledger')
        sortPropB = b.getFullNameFor('acknowledger')
      }

      if(this.state.sortBy === 'author') {
        sortPropA = a.getFullNameFor('author')
        sortPropB = b.getFullNameFor('author')
      }

      if(sortFunction) {
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        sortResult = collator.compare(sortPropA, sortPropB)
      }

      return this.state.sortDirection === 'asc' ? sortResult : sortResult * -1
    })
  }

  isSortByAscSelected(property) {
    return this.state.sortBy === property && this.state.sortDirection === 'asc'
  }

  isSortByDescSelected(property) {
    return this.state.sortBy === property && this.state.sortDirection === 'desc'
  }

  filterReports(reports) {
    return reports.filter(report => {
      if (this.critiqueFormTypes.includes(report.type)) {
        return this.props.canViewCritiqueForms;
      }

      return true;
    }).filter((report) => !report.getIsCompleted())
  }

  updateSignActors(data) {
    this.props.updateSignActorsForReport(data, this.state.editingApprover.phaseGuid, this.state.editingApprover.guid)
      .then(() => ApiPost(`/api/v1/reports/${this.state.editingApprover.guid}/send-reminder`))
      .then(() => {
        this.setState({
          editingApprover: null
        })
      })
  }


  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="report-table">

        <form className="table-filters">

          <div className="form-group">
            <select
              className="form-control"
              id="filterByType"
              name="filterByType"
              onChange={event => this.filterReportsByTypeAndProgress(event.target.value, this.state.filterByProgress)}
              value={this.state.filterByType}
            >
              <option value="">All</option>

              {this.departmentForms.map(form => (

                <option value={form.type}>{form.name}</option>

              ))}
            </select>

            <select
              className="form-control"
              id="filterByProgress"
              name="filterByProgress"
              onChange={event => this.filterReportsByTypeAndProgress(this.state.filterByType, event.target.value)}
              value={this.state.filterByProgress}
            >
              <option value="">All</option>
              <option value="scheduled">Scheduled</option>
              <option value="in-progress">In Progress</option>
            </select>
          </div>

        </form>
        {!this.state.filteredReports.length ? (
          <Alert color="primary"> No reports for selected type</Alert>
        ) : (
          <Fragment>
            <div className="table-scrollable">
              <table className="table table-stripped">
                <thead>
                <tr>
                  <th onClick={() => this.sortByProperty('date')}>
                    <div className="header">
                      <span>Date </span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('date')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('date')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th onClick={() => this.sortByProperty('name')}>
                    <div className="header">
                      <span>{this.props.oitShortLabel} Name </span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('name')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('name')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th onClick={() => this.sortByProperty('author')}>
                    <div className="header">
                      <span>Author Name </span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('author')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('author')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th onClick={() => this.sortByProperty('trainingPhaseHeader')}>
                    <div className="header">
                      <span>Phase</span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('trainingPhaseHeader')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('trainingPhaseHeader')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th onClick={() => this.sortByProperty('formName')}>
                    <div className="header">
                      <span>Type </span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('formName')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('formName')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th onClick={() => this.sortByProperty('status')}>
                    <div className="header">
                      <span>Progress</span>
                      <div className="filterActions">
                        <i
                          className={classNames("fa fa-angle-up", {
                            'selected': this.isSortByAscSelected('status')
                          })}
                        />
                        <i
                          className={classNames("fa fa-angle-down", {
                            'selected': this.isSortByDescSelected('status')
                          })}
                        />
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Actions </span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                {this.state.filteredReports.map((report, index) => {
                  return (
                    <ReportTableRow
                      key={index.toString()}
                      onAddScheduledReport={(reportGuid, type) => {
                        return this.props.addScheduledReport(reportGuid, type);
                      }}
                      onDeleteDraftReport={(reportGuid) => {
                        return this.props.removeDraftReport(reportGuid);
                      }}
                      onDeleteScheduledReport={(reportGuid) => {
                        return this.props.removeScheduledReport(reportGuid);
                      }}
                      onSendReminder={reportGuid => this.onSendReminder(reportGuid)}
                      onViewReport={reportGuid => this.props.viewReport(reportGuid)}
                      onEditReport={reportGuid => this.props.editReport(reportGuid)}
                      onChangeApprover={data => this.openEditingApprover(data)}
                      onNotifyApprover={data => this.notifyApprover(data)}
                      report={report}
                      users={this.props.users}
                    />
                  );
                })}
                </tbody>
              </table>
            </div>
          </Fragment>
        )}

        <Modal
          isOpen={!!this.state.editingApprover}
          onClose={() => this.setState({editingApprover: null})}
          size="lg"
          title={'Manage User sign permissions'}>
          {this.state.editingApprover
            &&
            <SignActorsManageSingle
              formType={this.state.editingApprover.formType}
              actor={this.state.editingApprover.actor}
              signFlowStep={this.state.editingApprover.signFlowStep}
              signFlow={this.state.editingApprover.signFlow}
              signActors={this.state.editingApprover.signActors}
              onSignActorsUpdate={(data) => this.updateSignActors(data)}
              trainingPhaseSignActors={this.state.editingApprover.trainingPhaseSignActors}
            />}
        </Modal>
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------


const mapStateToProps = (state) => {
  return {
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    userContext: state.common.userContext,
    forms: state.forms.list,
    settings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendReminder: (formData) => {
      return dispatch(reportsActionCreators.sendReminder(formData));
    },
    viewReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.viewReport(reportGuid));
    },
    removeScheduledReport: (reportGuid) => {
      return dispatch(reportsActionCreators.removeScheduledReport(reportGuid));
    },
    removeDraftReport: (reportGuid) => {
      return dispatch(reportsActionCreators.removeDraftReport(reportGuid));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
    updateSignActorsForReport: (signActors, phaseGuid, guid) => {
      return dispatch(oitsActionCreators.updateSignActorsForReport(signActors, phaseGuid, guid))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportTable);
